import { __awaiter, __generator } from "tslib";
import { updateNewUserState } from './updateNewUserState';
export function updateFirstRunState(state) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            updateNewUserState('FirstRunState', state);
            return [2 /*return*/];
        });
    });
}
//# sourceMappingURL=updateFirstRunState.js.map